import workspaceQuery from '../../queries/customer/CustomerPriceReviewLineWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CustomerPriceReviewLine: EntityType = {
  type: 'CustomerPriceReviewLine',
  title: 'Customer Price Review',
  workspaceUrl: '/Customer/CustomerPriceReviewLineWorkspace/',
  workspace: workspaceQuery,
  screenReference: 'CUSTOMER_PRICE_REVIEW',
};

export default CustomerPriceReviewLine;
